import { Add } from "@mui/icons-material";
import { useState } from "react";
import { Button, List, SearchInput, TopToolbar, useTranslate } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { useLocationFilterContext } from "../hooks/useLocationFilterContext";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { EmptyList } from "./EmptyList";
import { ListTitle } from "./ListTitle";
import PatientCreate from "./PatientCreate";
import { PatientDataGrid } from "./PatientDataGrid";

const PatientListActions = ({ disabled, onCreateClick }: { disabled: boolean; onCreateClick: () => void }) => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <Button
        label={translate("emptyList.patient.createButton")}
        variant="contained"
        disabled={disabled}
        onClick={onCreateClick}
        data-testid="create-button"
      >
        <Add />
      </Button>
    </TopToolbar>
  );
};

const PatientList = () => {
  const translate = useTranslate();
  const { organizationId: selectedOrganizationId } = useOrganizationContext();
  const { locationId: selectedLocationId } = useLocationFilterContext();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleCreateClick = () => {
    setIsCreateDialogOpen(true);
  };

  const handleCreateClose = () => {
    setIsCreateDialogOpen(false);
  };

  return (
    <>
      <List
        resource="Patient"
        filters={[<SearchInput key="search" source="search" alwaysOn />]}
        actions={<PatientListActions disabled={!selectedOrganizationId} onCreateClick={handleCreateClick} />}
        filter={{ organizationId: selectedOrganizationId, locationId: selectedLocationId }}
        title={<ListTitle title={translate("resources.Patient")} />}
        perPage={ROWS_PER_PAGE}
        empty={
          <EmptyList
            image="/images/patient.svg"
            description={translate("emptyList.patient.description")}
            createButton={{
              label: translate("emptyList.patient.createButton"),
              onClick: handleCreateClick,
              disabled: !selectedOrganizationId,
            }}
          />
        }
      >
        <PatientDataGrid />
      </List>
      {isCreateDialogOpen && <PatientCreate open={isCreateDialogOpen} onClose={handleCreateClose} />}
    </>
  );
};

export default PatientList;
